import React from 'react'
import { Row, Col, Button } from 'reactstrap'
import { Link } from 'react-router-dom'

// props Last

export default function ItemNext (props) {
  return (
    <Row>
      <Col>
        <Link to={props.nextItemLinkTo}>
          <Button 
            color='primary' 
            className='btn-block'
          >
            {props.last ? 'Return to Assignments' : 'Next Item >>'}
          </Button>
        </Link>
      </Col>
    </Row>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assignments/AssignmentItemView/ItemNext.js